import * as yup from 'yup';

export const Option = yup.object().shape({
  value: yup.string().required(),
});

export const OptionNulable = yup.object().shape({
  value: yup.string().nullable(),
});

const sversanasAndAnimalsSchema = yup.object().shape({
  animal_id: yup.string(),
  name: yup.string(),
  breed_code: yup.string(),
  age: yup.string().nullable(),
  weight_code: yup.string().nullable(),

  // weight_type: OptionNulable,
  weight: yup.string().nullable(),
  breast_circumference: yup.string().nullable(),
  neck_height: yup.string().nullable(),
  lower_back_height: yup.string().nullable(),
  modified_weigth: yup.string().nullable(),
});

export const schema = yup.object().shape({
  species: OptionNulable,
  barn_ldc_nr: OptionNulable,
  animal_id: OptionNulable,
  status: yup.string().required(),
  date: yup.date().required(),
  sversanasAndAnimals: yup.array().of(sversanasAndAnimalsSchema),
  notes: yup.string().max(4000).nullable(),
  file: yup.mixed(),
});
